import React from 'react';
import styles from './Notification.module.css';
import { NotificationType } from '../types';
import NotificationFtux from './NotificationFtux';
import NotificationItem from './NotificationItem';
import { updateNotificationStatus } from '../../../../services/usageRights.service';

interface NotificationProps {
  notifications: NotificationType[];
  triggerFetch: () => unknown;
}

function Notification({ notifications, triggerFetch }: NotificationProps) {
  return (
    <div className={styles.notificationContainer}>
      <div className={styles.notificationContainerHeader}>
        <span className={styles.notificationContainerHeaderTitle}>Notifications</span>
        <div
          role="presentation"
          onClick={async () => {
            await updateNotificationStatus({ notificationIds: notifications.map((n) => n._id) });
            triggerFetch();
          }}
          className={styles.notificationContainerHeaderRight}
        >
          Mark all as read
        </div>
      </div>
      {notifications.length === 0 ? (
        <NotificationFtux />
      ) : (
        <div className={styles.notificationItemContainers}>
          {notifications.map((notification) => (
            <NotificationItem key={notification._id} notification={notification} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Notification;
